// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Topbar container */
.topbar {
  background-color: #f2f7fe;
  height: 70px;
  width: 100%;
  padding: 5px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
}

/* Left section: Logo + Brand */
.topbar-left {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 35.18px;
}

.brand-text {
  font-size: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #005eef;
}

/* Right section: Buttons + Dropdowns */
.icon-section {
  display: flex;
  align-items: center;
  gap: 22px;
}

.icon {
  width: 20px;
  height: 20px;
}

.user-icon {
  font-size: 29px;
  color: white;
}

/* User dropdown menu */
.user-dropdown-menu {
  z-index: 1055;
  width: 220px;
  padding: 12px;
  font-size: 0.875rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-dropdown-name {
  font-weight: 500;
  font-size: 14px;
  padding: 8px 2px 0;
}

.user-dropdown-email {
  font-size: 12px;
  color: #838fb4;
  padding: 6px 2px 8px;
}

.user-dropdown-logout {
  font-size: 14px;
  padding: 12px 8px 8px 2px;
  color: #838fb4;
}

.user-dropdown-element {
  font-size: 14px;
  padding: 12px 8px 8px 2px;
  color: #838fb4;
}
.user-dropdown-divider {
  margin: 0.25rem 0;
}

.user-dropdown-logout:hover {
  background-color: #f8d7da;
  border-right: 5px solid #f44d5b;
  border-radius: 5px;
}

.user-dropdown-element:hover {
  background-color: var(--uni_std_clr);
  border-right: 5px solid var(--uni_std_clr_dark);
  border-radius: 5px;
  color: white;
}

.help-dropdown-menu {
  min-width: 180px;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  padding: 0.5rem;
  font-size: 0.8rem;
}

.help-dropdown-menu .dropdown-item {
  color: gray;
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
}

.help-dropdown-menu .dropdown-item:hover {
  background-color: #e6f2ff !important;
  color: #0066cc !important;
  border-right: 5px solid #0066cc;
  border-radius: 5px;
}

.dropdown-toggle::after {
  display: none !important;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-profile-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

/* Help & Info Button */
.help-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 117px;
  height: 36px;
  padding: 6px;
  background-color: #f2f7fe;
  color: #005eef;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.help-info-btn:hover,
.help-info-btn:focus,
.help-info-btn:active {
  background-color: #1f36c7 !important;
  color: #fff;
  box-shadow: none;
}

.dropdown-icon {
  width: 22px;
  height: 22px;
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
  top: 1px;
}

/* Apply blue tint on parent hover */
.help-dropdown-menu .dropdown-item:hover .dropdown-icon {
  filter: invert(35%) sepia(98%) saturate(2865%) hue-rotate(205deg) brightness(95%) contrast(92%);
}

.help-info-icon {
  margin-right: 3px;
  position: relative;
  top: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Topbar.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6CAA6C;AAC/C;;AAEA;;;EAGE,oCAAoC;EACpC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA,oCAAoC;AACpC;EACE,+FAA+F;AACjG;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV","sourcesContent":["/* Topbar container */\n.topbar {\n  background-color: #f2f7fe;\n  height: 70px;\n  width: 100%;\n  padding: 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Left section: Logo + Brand */\n.topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n}\n\n.logo-img {\n  width: 32px;\n  height: 35.18px;\n}\n\n.brand-text {\n  font-size: 24px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #005eef;\n}\n\n/* Right section: Buttons + Dropdowns */\n.icon-section {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.icon {\n  width: 20px;\n  height: 20px;\n}\n\n.user-icon {\n  font-size: 29px;\n  color: white;\n}\n\n/* User dropdown menu */\n.user-dropdown-menu {\n  z-index: 1055;\n  width: 220px;\n  padding: 12px;\n  font-size: 0.875rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.user-dropdown-name {\n  font-weight: 500;\n  font-size: 14px;\n  padding: 8px 2px 0;\n}\n\n.user-dropdown-email {\n  font-size: 12px;\n  color: #838fb4;\n  padding: 6px 2px 8px;\n}\n\n.user-dropdown-logout {\n  font-size: 14px;\n  padding: 12px 8px 8px 2px;\n  color: #838fb4;\n}\n\n.user-dropdown-element {\n  font-size: 14px;\n  padding: 12px 8px 8px 2px;\n  color: #838fb4;\n}\n.user-dropdown-divider {\n  margin: 0.25rem 0;\n}\n\n.user-dropdown-logout:hover {\n  background-color: #f8d7da;\n  border-right: 5px solid #f44d5b;\n  border-radius: 5px;\n}\n\n.user-dropdown-element:hover {\n  background-color: var(--uni_std_clr);\n  border-right: 5px solid var(--uni_std_clr_dark);\n  border-radius: 5px;\n  color: white;\n}\n\n.help-dropdown-menu {\n  min-width: 180px;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n  padding: 0.5rem;\n  font-size: 0.8rem;\n}\n\n.help-dropdown-menu .dropdown-item {\n  color: gray;\n  padding: 8px;\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n.help-dropdown-menu .dropdown-item:hover {\n  background-color: #e6f2ff !important;\n  color: #0066cc !important;\n  border-right: 5px solid #0066cc;\n  border-radius: 5px;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-profile-img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Help & Info Button */\n.help-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 117px;\n  height: 36px;\n  padding: 6px;\n  background-color: #f2f7fe;\n  color: #005eef;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.help-info-btn:hover,\n.help-info-btn:focus,\n.help-info-btn:active {\n  background-color: #1f36c7 !important;\n  color: #fff;\n  box-shadow: none;\n}\n\n.dropdown-icon {\n  width: 22px;\n  height: 22px;\n  margin-right: 8px;\n  flex-shrink: 0;\n  position: relative;\n  top: 1px;\n}\n\n/* Apply blue tint on parent hover */\n.help-dropdown-menu .dropdown-item:hover .dropdown-icon {\n  filter: invert(35%) sepia(98%) saturate(2865%) hue-rotate(205deg) brightness(95%) contrast(92%);\n}\n\n.help-info-icon {\n  margin-right: 3px;\n  position: relative;\n  top: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
